module.exports = __webpack_public_path__ + "static/scale-model-of-world's-largest-cap-gun-in-kansas-city-missouri-488a90ecff9515535ad16129a743f2c1.png";